module.exports = __webpack_public_path__ + "static/media/notificacao.0d2b86ba.svg";